
import Component from '../../../assets/scripts/modules/component'
import SwiperWrapper from '../../../assets/scripts/modules/swiper-wrapper'
import { cubicOut } from '../../../assets/scripts/utilities/easings'

const SWIPER_OPTIONS = {
  loop: false,
  slidesPerView: 1,
  spaceBetween: 15,
  grabCursor: false,
  breakpoints: {
    530: { slidesPerView: 2 },
    800: { slidesPerView: 3 },
    1180: { slidesPerView: 4 }
  }
}

const clampNumber = (value, min, max) => Math.max(min, Math.min(max, value))

export default class ThemeCardCarouselComponent extends Component {
  async init () {
    this.initSwiper()
    this.initDisabledParallax() // tijdelijk uitgezet
    // this.initParallax() // tijdelijk uitgezet
  }

  initSwiper () {
    this.container = this.element.querySelector('.theme-card-carousel__swiper-container')

    if (!this.container) {
      return
    }

    this.loadSwiper()
  }

  loadSwiper () {
    const slides = [...this.container.querySelectorAll('.swiper-slide')]
    const highlightedSlideIndex = slides.indexOf(slides.find(slide => slide.querySelector('.theme-card--highlighted')))
    const initialSlide = highlightedSlideIndex !== -1 ? highlightedSlideIndex : 0
    const options = { ...SWIPER_OPTIONS, initialSlide }

    this.swiperWrapper = new SwiperWrapper(this.container, options)

    slides.forEach(slide => slide.addEventListener('mouseenter', () => {
      slides.filter(slide2 => slide2 !== slide).forEach(slide2 => slide2.classList.add('theme-card-carousel__swiper-slide--hovering-other'))
    }))

    slides.forEach(slide => slide.addEventListener('mouseleave', () => {
      slides.filter(slide2 => slide2 !== slide).forEach(slide2 => slide2.classList.remove('theme-card-carousel__swiper-slide--hovering-other'))
    }))
  }

  // START tijdelijk uitgezet
  initDisabledParallax () {
    this.title = this.element.querySelector('.theme-card-carousel__title-copy')

    if (!this.title) {
      return
    }

    this.title.style.display = 'none'
  }
  // END tijdelijk uitgezet

  initParallax () {
    this.title = this.element.querySelector('.theme-card-carousel__title-copy')
    this.percentage = null

    if (!this.title) {
      return
    }

    window.addEventListener('scroll', () => this.updateParallax(), { passive: true })
    window.addEventListener('resize', () => this.updateParallax(), { passive: true })
    this.updateParallax()
  }

  updateParallax () {
    const rect = this.element.getBoundingClientRect()
    // const height = this.title.offsetHeight
    const clampLimit = (window.innerHeight / 2)

    // TODO: Fix this calculation, it's full of magic values
    const centerlineOffset = (window.innerHeight / 2) + (rect.height / 1.75) + rect.top - (clampLimit * 2) // eslint-disable-line smells/no-complex-string-concat

    const clampedOffset = clampNumber(centerlineOffset, -clampLimit * 2, clampLimit * 2)
    const clampedPercentage = 100 / clampLimit * clampedOffset
    const adjustedPercentage = clampedPercentage // No adjustment

    if (adjustedPercentage !== this.percentage) {
      const easedPercentage = cubicOut(adjustedPercentage) / cubicOut(100) * 100
      const clipPath = `polygon(0% 0%, 100.1% 0%, 100.1% ${easedPercentage}%, 0% ${easedPercentage}%)`

      this.title.style.clipPath = clipPath
      this.title.style.webkitClipPath = clipPath
    }

    this.percentage = adjustedPercentage
  }
}

window.addEventListener('init-load', () => document.querySelectorAll('.theme-card-carousel').forEach(element => {
  element.instance = element.instance || new ThemeCardCarouselComponent(element)
}))
